module.exports = __webpack_public_path__ + "img/TeamResult.ecc2b3a8.svg";